module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1053-dac97a347220d2763a2cfa2d4eaa6a55.png";